import { useTranslationStore } from 'stores/TranslationStore';

export let translatedTextDataCache: { [text: string]: string } = {};

/**
 * Load specific set of translated strings
 * @param texts to load translations for
 * @returns key value pairs of translated text
 * @deprecated This works, but requires imperative logic to update the data backing specific components, instead of letting components subscribe to
 * translation data and reactively update themselves. Please use [TranslationStore](./src/stores/TranslationStore.ts) instead.
 */
export async function getTranslatedStrings(texts: string[]) {
  await useTranslationStore.getState().actions.loadPhrases(texts);
  const phrases = useTranslationStore.getState().phrases;
  let translatedTextData: { [text: string]: string } = {};
  texts.forEach(txt => (translatedTextData[txt] = phrases.get(txt) || txt));

  return translatedTextData;
}

export async function getTranslatedString(text: string) {
  if (!text) return text;

  let translatedText: string = useTranslationStore.getState().phrases.get(text) || '';

  if (translatedText) return translatedText;
  else {
    const translatedTexts = await getTranslatedStrings([text]);
    return translatedTexts[text];
  }
}

export const TranslationHelpers = {
  getTranslatedString,
  getTranslatedStrings,
};
